module.exports = __webpack_public_path__ + "assets/img/2f7f-aw.svg";